import { JointEntityShape } from '../Shape/JointEntityShape';
import { Association } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Association';
import { MDAConstant } from '../../Base/MDAConstant';
import { AssoLink } from '../../BaseShape/AssoLink';
import { MDRepository } from '../../../MD/MDRepository';

export class JointAssociationLink extends AssoLink {
  constructor(opt?: any) {
    super(opt);
    this.set('type', 'mst.JointAssociationLink');
    this.attr({
      line: {
        stroke: 'maroon', // 深红色
        targetMarker: { fill: 'none', d: 'M 10 -5 L 0 0 L 10 5 L 0 0 z' }
      }
    });
    // 反序列化调用，手工创建的时候不调用
    if (opt) {
      this.setMD(opt?.shape, opt?.model, true);
    }
  }

  changeTarget(source: joint.dia.Element, target: joint.dia.Element) {
    if (target instanceof JointEntityShape && source instanceof JointEntityShape) {
      const sourceEntity = source.entity;
      const targetEntity = target.entity;
      let relationship = this.element() as Association;
      if (relationship === null) {
        relationship = MDRepository.createAssociation(null, sourceEntity, targetEntity, false);
      }
      relationship.name = `${sourceEntity.name}_association_${targetEntity.name}`;
      relationship.displayName = `${sourceEntity.displayName}_关联_${targetEntity.displayName}`;
      relationship.description = relationship.displayName;
      relationship.targetEntity = targetEntity;
      this.setModel(relationship);
      sourceEntity.targetAssociations.push(relationship);
      targetEntity.sourceAssociations.push(relationship);
      return relationship;
    }
    return null;
  }

  get association(): Association {
    return this.element() as Association;
  }

  public shapeType(): string {
    return MDAConstant.Link.ADD_ASSOCIATION;
  }

  /**
   * 检查源和目标类型对当前关系是否有效
   * 关联关系：仅用于实体与实体
   * @param sourceType 源类型
   * @param targetType 目标类型
   * @returns 有效返回true
   */
  public checkShapeType(sourceType: string, targetType: string): boolean {
    if (sourceType === MDAConstant.Type.ADD_ENTITY && targetType === MDAConstant.Type.ADD_ENTITY) {
      return true;
    }
    return false;
  }
}
